import {createReducer} from '@reduxjs/toolkit';
import {
  setVisibleCollection,
  selectCollectionFeatureRef,
  setShowManageQuota,
} from '@src/actions/featureCollections.ts';
import {type FeatureCollectionId} from '@src/types/featureCollections.ts';

type FeatureCollectionsState = {
  showManageQuota: boolean;
  selectedFeatureRef: FeatureCollectionId | null;
  visibleCollectionId: FeatureCollectionId | null;
};

export const initialState: FeatureCollectionsState = {
  // Whether we're in quota reservation mode
  showManageQuota: false,

  // The reference of the currently selected feature.
  selectedFeatureRef: null,

  // The hash ID of the currently visible collection.
  visibleCollectionId: null,
};

export default createReducer(initialState, builder => {
  builder.addCase(setVisibleCollection, (state, {payload}) => {
    state.visibleCollectionId = payload ?? null;
  });

  builder.addCase(selectCollectionFeatureRef, (state, {payload}) => {
    state.selectedFeatureRef = payload ?? null;
  });

  builder.addCase(setShowManageQuota, (state, {payload}) => {
    state.showManageQuota = !!payload;
  });
});
